import type { NotificationCategory, NotificationPageView, NotificationView } from 'shared';
import { http } from './client';

export const notificationApi = {
  list: (
    input: {
      workspaceId?: string;
      category?: NotificationCategory;
      unreadOnly?: boolean;
      cursor?: string;
      limit?: number;
    } = {},
  ) => http.get<NotificationPageView>('/notifications', { params: input }),
  markRead: (notificationId: string) =>
    http.patch<NotificationView>(`/notifications/${notificationId}/read`),
  markAllRead: () => http.patch<void>('/notifications/read'),
  remove: (notificationId: string) => http.delete<void>(`/notifications/${notificationId}`),
  clear: () => http.delete<void>('/notifications'),
};
